import styled from 'styled-components';
// import {device} from 'styled/device';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 30px;
  font-family: 'Poppins', sans-serif;
`;
